import React, { useEffect } from "react";
import { DatePicker } from "components/DatePicker";
import {
  convertDateToUnixTimestamp,
  parseDateFromUnixTimestamp
} from "core/datetime/unix-timestamp";
import { styled } from "@mui/material/styles";

export interface AttributeDateFieldProps {
  value: number;
  onChangeValue: (value: string | number | Date) => void;
  placeholder?: string;
  size: "small" | "medium";
  dense: boolean;
  enableLabel: boolean;
  inputAdornment: React.ReactNode;
}

export const AttributeDateField = ({
  value,
  onChangeValue,
  size,
  enableLabel,
  inputAdornment
}: AttributeDateFieldProps): JSX.Element => {
  useEffect(() => {
    // if date is not set, set it to the current date
    if (!value) {
      onChangeValue(convertDateToUnixTimestamp(new Date()));
    }
  }, [value, onChangeValue]);

  const handleChangeValue = (value: Date): void => {
    // Dates in Attributes are stored as unix timestamps.
    // Need to convert the javascript date object back into a unix timestamp before saving it into the attribute
    onChangeValue(convertDateToUnixTimestamp(value));
  };

  return (
    <InputWrapper>
      <DatePicker
        fullWidth
        disableFuture={false}
        label={enableLabel ? "Attribute Value" : ""}
        // Dates stored in Attributes are stored as unix timestamps
        // So need to parse them into date objects to work with the DatePicker
        date={parseDateFromUnixTimestamp(value)}
        onChange={handleChangeValue}
        onError={() => {}}
        size={size ?? "medium"}
        data-qa="CM-DateEdit-Attribute-Value"
      />
      {inputAdornment}
    </InputWrapper>
  );
};

const InputWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing(1)};
`;
InputWrapper.displayName = "InputWrapper";
